import { computed, inject, toRefs } from "vue";

export interface IValidationState {
    validationHandles: IValidationHandle[],
    messages: string[],
    active: boolean,
}

export interface IValidationHandle{
    label: string,
    message: string,
    check: Function,
}

export const useValidation = (label:string, valueToCheck: Function) => {
    var validationState = inject('validation') as IValidationState;

    const { active } = toRefs(validationState)

    const isRequired = () => {
        validationState.validationHandles.push({
            label: label,
            message: `"${label}" ist ein Pflichtfeld.`,
            check: (): boolean => {
                return valueToCheck() !== null && valueToCheck() !== undefined && valueToCheck() !== ''
            }
        })
    }

    const fitsMaxLength = (maxLength: number) => {
        validationState.validationHandles.push({
            label: label,
            message: `"${label}" darf maximal ${maxLength} Zeichen lang sein.`,
            check: (): boolean => {
                return (valueToCheck()?.length ?? 0) <= maxLength
            }
        })
    }

    const isInRange = (min?: number, max?: number) => {
        let message = '';
        if (min !== undefined && max !== undefined) {
            message = `"${label}" muss zwischen ${min} und ${max} liegen.`;
        } else if (min !== undefined) {
            message = `"${label}" muss mindestens ${min} sein.`;
        } else if (max !== undefined) {
            message = `"${label}" darf maximal ${max} sein.`;
        }

        validationState.validationHandles.push({
            label: label,
            message: message,
            check: (): boolean => {
                const value = valueToCheck();
                
                if (value === null || value === undefined || value === '')
                    return true;
                
                const numValue = Number(value);
                
                if (isNaN(numValue))
                    return true;

                let valid = true;
                
                if (min !== undefined && numValue < min)
                    valid = false;
                
                if (max !== undefined && numValue > max)
                    valid = false;
                
                return valid;
            }
        })
    }

    const isValid = computed(() => {
        var valid = true;
        
        validationState.validationHandles.filter((h:IValidationHandle) => h.label == label)
        .forEach((h:IValidationHandle) => {
            var result = h.check();
            valid = valid && result;

            var index = validationState.messages.indexOf(h.message);

            if(!result && index < 0)
                validationState.messages.push(h.message)
            else if(result && index > -1)
                validationState.messages.splice(index,1)
        })
        
        return valid || !active.value ;
    })

    return {
        validationState,

        isRequired,
        isValid,
        fitsMaxLength,
        isInRange
    };
}